import React, {Component} from "react"

class EmptyLayout extends Component {
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    )
  }
}

export default EmptyLayout



// WEBPACK FOOTER //
// ./src/theme/oehme/layout/EmptyLayout.js